// Package Imports
import { message } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Internal Imports
import { uniformTimestamp, dateToEpoch } from "../utils/helpers";
import useInviteURLData from "../hooks/useInviteURLData";
import SimpleLoader from "../components/simpleLoader";
import AuthForm from "../components/forms/AuthForm";
import AuthPageShell from "../components/forms/AuthPageShell";
import { HeadingOne } from "../components/typography";
import mixpanelService from "../services/mixpanel";
import bugfenderHelper from "../services/bugfender";

const InviteMember = () => {
  const navigate = useNavigate();
  const { inviteData, inviteError } = useInviteURLData();

  // SIDE-EFFECT - Invite Data [Failure]
  useEffect(() => {
    // CHECK - Invite Error
    if (!inviteError) return;

    const errorMessage = "We've encountered an issue processing your invite. Please contact support if the issue persists.";

    const processInviteError = async () => {
      try {
        console.error("INVITE-MEMBER-ERROR:\n", inviteError);
        message.error(errorMessage, 10);
        bugfenderHelper.error(inviteError)
        navigate("/login/sso/sso-app", { replace: true });
      } catch (err) {
        console.error("PROCESS-INVITE-MEMBER-HOOK-ERROR:\n", err);
        bugfenderHelper.error(inviteError)
      }
    }

    processInviteError();
  }, [inviteError]);

  // SIDE-EFFECT - Process Invite
  useEffect(() => {
    // CHECK - Invite Data
    if (inviteData === null) return;

    const processMemberInvite = async () => {
      try {
        const currentTime = uniformTimestamp();
        const inviteExpiryTime = dateToEpoch(inviteData.invite.expires_timestamp);

        // CHECK - Time Data
        if (!currentTime || !inviteExpiryTime) {
          throw new Error("Time data is invalid - currentTime OR inviteExpiryTime");
        }

        // CHECK - Invite Expiry
        if (inviteExpiryTime < currentTime) {
          message.info("Your invite has expired. Please contact support.", 10);
          bugfenderHelper.error("Invite has expired")
          navigate("/login/sso/sso-app", { replace: true });
          return;
        }

        mixpanelService.people.set_once("NULL", {
          "First_sign_in": true,
          email: inviteData.invite.email
        });

        mixpanelService.people.set({
          email: inviteData.invite.email,
          inviteId: inviteData.invite.id,
          inviteExpiryTime: inviteExpiryTime
        });

        navigate("/invite/sso/sign-up", {
          replace: true,
          state: {
            invite: {
              email: inviteData.invite.email,
              inviteId: inviteData.invite.id,
              inviteResult: inviteData
            }
          }
        });
      } catch (err) {
        bugfenderHelper.error(err);
        
        console.error("PROCESS-MEMBER-INVITE-HOOK-ERROR:\n", err);
        message.error("We've encountered an issue processing your invite link. Please contact support.", 10);

        navigate("/login/sso/sso-app", { replace: true });
      }
    }

    processMemberInvite();
  }, [inviteData]);

  return (
    <AuthPageShell>
      <AuthForm>
        <HeadingOne className="text-[#003eb2] text-center text-2xl font-semibold mb-6">
          Loading invite
        </HeadingOne>
        <SimpleLoader />
      </AuthForm>
    </AuthPageShell>
  );
}

export default InviteMember;
